export const initialFormValues = {
  amount: ''
}
